document.getElementById('overview').style.display = "none";
document.getElementById('benefits').style.display = "block";
document.getElementById('faq').style.display = "none";
function clickTab(evt, tabName) {
  googleAnalyticTabChange(tabName);

  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active-tab", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active-tab";
}

function googleAnalyticTabChange(selectedTab) {

  var url = window.location.pathname;
  url = url.split('/');
  const bflJourney = url.includes('marketplace');
  if (bflJourney) {
    var dataLayer = window['dataLayer'];
    dataLayer.push({
      'event': 'tab_header_navigation',
      'pageType': 'Get Quote Page',            //E.g. Get Quote Page, Product Listing Page
      'productName': 'Health Insurance',         //E.g. Health Insurance, Motor Insurance
      'clickText': selectedTab,            //E.g. Overview, Benefit, faqs
      'customerType': '',        //E.g. ETB, PTB, NTB
      'customerId': '',          //If user is ETB
      'userId': '',          //If user is PTB, NTB
      'leadId': '',
      'applicationId': sessionStorage.getItem('applicationId'),
    });
  }
}

function googleAnalyticLinkClick(text) {
  var link = '';
  if (text == 'compare health insurance') {
    link = 'https://www.bajajfinservmarkets.in/insurance/health-insurance/compare-health-insurance.html';
  } else if (text == 'health insurance policy') {
    link = 'https://www.bajajfinservmarkets.in/insurance/health-insurance.html';
  }

  var url = window.location.pathname;
  url = url.split('/');
  const bflJourney = url.includes('marketplace');
  if (bflJourney) {
    var dataLayer = window['dataLayer'];
    dataLayer.push({
      'event': 'link_click',
      'pageType': 'Get Quote Page',            //E.g. Get Quote Page, Product Listing Page
      'sectionHeading': 'Overview',      //E.g. Overview, benefits, faqs
      'productName': 'Health Insurance',         //E.g. Health Insurance, Motor Insurance
      'section': 'BodyText',                     //E.g. Card, BodyText, etc.
      'clickText': text,           //E.g. pre-existing disease, health insurance policy
      'destinationUrl': link,      //E.g. https://www.bajajfinservmarkets.in/insurance/health-insurance/compare-health-insurance.html  
      'customerType': '',        //E.g. ETB, PTB, NTB
      'customerId': '',          //If user is ETB
      'userId': '',          //If user is PTB, NTB
      'leadId': '',
      'applicationId': sessionStorage.getItem('applicationId'),
    });
  }
}

// FAQ functionality
var acc = document.getElementsByClassName("faq-accordion");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("acc-active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
